var App = App || {};

App.PayMyBill = (function ($) {
	"use strict";

	function init() {
		var $checkoutButton = $("#pay-bill-checkout"),
			$binVerifyForm = $("form#bin-verify-form"),
			$binLookup = $binVerifyForm.find("#bin-lookup"),
			$binVerifyButton = $binVerifyForm.find("#bin-verify"),
			$skip = $binVerifyForm.find("#skip-bin"),
			$paymentFor = $binVerifyForm.find("#payment-for");

		$skip.on('change', function () {
			if ($(this).is(':checked')) {
				$binLookup.val("PG100");
				$binVerifyForm.trigger("submit");
				$binVerifyButton.prop("disabled", true);
			} else {
				$binVerifyButton.prop("disabled", false);
			}
		});

		$binVerifyForm.on("submit", function (e) {
			e.preventDefault();

			$binVerifyForm.find("input").each((_, el) => el.setCustomValidity(""));

			$.ajax({
				url: `/api/account/find/${$binLookup.val()}`,
				contentType: 'application/json; charset=utf-8',
				method: 'GET',
				dataType: 'json'
			}).done(function (response) {
				if (!response) {
					$binLookup[0].setCustomValidity("Unable to verify BIN.");
					$paymentFor.text("Unable to verify BIN.");
					$("#step-to-invoice").prop('disabled', true);
					return;
				};

				if (!response.success) {
					$binLookup[0].setCustomValidity(response?.message || "Unable to verify BIN.");
					$paymentFor.text(response?.message || "Unable to verify BIN.");
					$("#step-to-invoice").prop('disabled', true);
					return;
				}

				if (response.success) {
					$("#account-id").val(response.data.id);
					$paymentFor.text(response.data.name);
					$("#step-to-invoice").prop('disabled', false);
					return;
				}
			});

			$binVerifyForm[0].checkValidity();
			$binVerifyForm.addClass("was-validated");
		});



		$("#payment-amount").on("change", function () {
			var amount = $(this).val();
			if (!amount || amount > 2700) {
				$checkoutButton.prop('disabled', true);
			} else {
				$checkoutButton.prop('disabled', false);
			}
		})

		$checkoutButton.on("click", function () {
			var key = $(this).data("key"),
				accountId = $("#account-id").val(),
				invoice = $("#invoice-number").val(),
				amount = parseFloat($("#payment-amount").val()),
				comment = $("#payment-comment").val(),
				cartUrl = $(this).data("cart");

			const formattedPrice = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD'
			}).format(amount);

			App.Commerce
				.Add(key, null, 1, {
					"cartDescription": `Invoice payment - ${invoice}: ${formattedPrice} `,
					"priceOverride": amount,
					"billPay": {
						"accountId": accountId,
						"invoice": invoice,
						"comment": comment
					}
				})
				.done(function () {
					window.location.href = cartUrl;
				}).done(function () {
					window.location.href = cartUrl;
				});
		})

	
	
		function focusFirstInVisibleStep() {
			var $panel = $('.step-content:visible').first();
			if (!$panel.length) return;

			var $el = $panel.find(
				'input:not([type="hidden"]):not(:disabled),' +
				'select:not(:disabled),' +
				'textarea:not(:disabled),' +
				'[tabindex]:not([tabindex="-1"])'
			).first();

		
			if ($el.length) {
				
				$el[0].focus({ preventScroll: true });
				$el[0].scrollIntoView({ block: 'start' });
			} else {
				if (!$panel.attr('tabindex')) $panel.attr('tabindex', '-1');
				$panel[0].focus({ preventScroll: true });
				$panel[0].scrollIntoView({ block: 'start' });
			}
		}

		
		$(document).on('click', '.btn-next, .btn-back', function () {
			requestAnimationFrame(function () {
				requestAnimationFrame(function () {
					focusFirstInVisibleStep();
				});
			});
		});


	}

	return {
		init: init
	};

})(jQuery);

$(function () {
	App.PayMyBill.init();
	
});
